export default __webpack_public_path__ + "static/media/next.0cd580a9.svg";